export class TimeDependencyConfig {
  actionExecuted: boolean = false;
  actionExecutionThreshold: number = 0;
  lastTimeConditionMet: number = 0;
}